import React from "react";
import Sidebar from "../components/sidebar";
import PdfChatArea from "../components/pdf-chat-area";
import UseAngelChat from "../utils/use-angel-chat";

const ChatAngel = () => {
  const { handleSelectConversation, conversations } = UseAngelChat();

  return (
    <div className="flex w-full h-screen bg-[#0f1829] overflow-hidden">
      <Sidebar conversations={conversations} handleSelectConversation={handleSelectConversation} />
      <div className="flex-1 overflow-hidden min-w-0">
        <PdfChatArea />
      </div>
    </div>
  );
};

export default ChatAngel;
